import { Hsluv } from './hsluv';

const BASE_NAME = 'global';

interface ColorGenSettings {
  base_hex: string;

  num_brighter: number;
  num_darker: number;

  step_brighter: number;
  step_darker: number;
}
const base_colors: { [key: string]: ColorGenSettings } = {
  main: {
    base_hex: '#402560',
    num_brighter: 9,
    num_darker: 3,
    step_brighter: 8,
    step_darker: 5,
  },
  secondary: {
    base_hex: '#294356',
    num_brighter: 9,
    num_darker: 4,
    step_brighter: 7,
    step_darker: 5,
  },
  red: {
    base_hex: '#f64753',
    num_brighter: 6,
    num_darker: 3,
    step_brighter: 7,
    step_darker: 10,
  },
  yellow: {
    base_hex: '#f7c94a',
    num_brighter: 5,
    num_darker: 4,
    step_brighter: 3,
    step_darker: 8,
  },
  green: {
    base_hex: '#52b729',
    num_brighter: 6,
    num_darker: 4,
    step_brighter: 5,
    step_darker: 15,
  },
  gray: {
    base_hex: '#797a8b',
    num_brighter: 8,
    num_darker: 5,
    step_brighter: 6,
    step_darker: 5,
  },
} as const;

const all_vars: { [key: string]: string } = {};
const color_vars: { [key: string]: string } = {};

function createVariants(name: string, settings: ColorGenSettings) {
  const hsluv = new Hsluv();

  all_vars[`--${BASE_NAME}-${name}`] = settings.base_hex;
  color_vars[`--${BASE_NAME}-${name}`] = settings.base_hex;

  // gen lighter
  const lighter_prefix = `--${BASE_NAME}-${name}-lighter-`;
  for (let i = 1; i <= settings.num_brighter; i++) {
    hsluv.hex = settings.base_hex;
    hsluv.hexToHsluv();
    hsluv.hsluv_l += settings.step_brighter * i;
    hsluv.hsluvToHex();

    all_vars[lighter_prefix + i] = hsluv.hex;
    color_vars[lighter_prefix + i] = hsluv.hex;
  }

  // gen lighter
  const darker_prefix = `--${BASE_NAME}-${name}-darker-`;
  for (let i = 1; i <= settings.num_darker; i++) {
    hsluv.hex = settings.base_hex;
    hsluv.hexToHsluv();
    hsluv.hsluv_l -= settings.step_darker * i;
    hsluv.hsluvToHex();

    all_vars[darker_prefix + i] = hsluv.hex;
    color_vars[darker_prefix + i] = hsluv.hex;
  }
}

for (const [name, settings] of Object.entries(base_colors)) {
  createVariants(name, settings);
}

export default all_vars;
export { color_vars };
